import { render } from "./SentryTest.vue?vue&type=template&id=5075cee1&scoped=true&lang=pug"
import script from "./SentryTest.vue?vue&type=script&setup=true&lang=js"
export * from "./SentryTest.vue?vue&type=script&setup=true&lang=js"

import "./SentryTest.vue?vue&type=style&index=0&id=5075cee1&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5075cee1"]])

export default __exports__